var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'editor-div '+(_vm.isReadOnly?'readonly':'')},[_c('div',{staticClass:"quill-editor",attrs:{"id":_vm.editorID}})])
}
var staticRenderFns = []

export { render, staticRenderFns }